
import axios from 'axios';

const axiosInstance = axios.create({
    headers: {
        common: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        // Add any other default headers as needed
    }
});

export default axiosInstance;